import { useTranslation } from "react-i18next";

const transactionTypeOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "SALE",
      title: t("options.transType.sale"),
      value: "SALE",
    },
    {
      key: "SALE_VOID",
      title: t("options.transType.sale_void"),
      value: "SALE_VOID",
    },
    {
      key: "REFUND",
      title: t("options.transType.refund"),
      value: "REFUND",
    },
    {
      key: "ATUH",
      title: t("options.transType.auth"),
      value: "AUTH",
    },
    {
      key: "AUTH_VOID",
      title: t("options.transType.auth_void"),
      value: "AUTH_VOID",
    },
    {
      key: "AUTH_COMPLETE",
      title: t("options.transType.auth_complete"),
      value: "AUTH_COMPLETE",
    },
    {
      key: "AUTH_COMPLETE_VOID",
      title: t("options.transType.auth_complete_void"),
      value: "AUTH_COMPLETE_VOID",
    },
    {
      key: "TIPS_ADJUSTMENT",
      title: t("options.transType.tips_adjustment"),
      value: "TIPS_ADJUSTMENT",
    },
    {
      key: "TIPS_ADJUSTMENT_VOID",
      title: t("options.transType.tips_adjustment_void"),
      value: "TIPS_ADJUSTMENT_VOID",
    },
    {
      key: "SALE_REVERSAL",
      title: t("options.transType.sale_reversal"),
      value: "SALE_REVERSAL",
    },
    {
      key: "VOID_REVERSAL",
      title: t("options.transType.void_reversal"),
      value: "VOID_REVERSAL",
    },
    {
      key: "AUTH_REVERSAL",
      title: t("options.transType.auth_reversal"),
      value: "AUTH_REVERSAL",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default transactionTypeOptions;
